// extracted by mini-css-extract-plugin
export default {"section-title":"Privacy_section-title__k3QQi","title":"Privacy_title__NU-64","paragraph":"Privacy_paragraph__f0R4h","link":"Privacy_link__rP+j6"};